import React from "react";
import { TodoPlaceholder } from "@cms/ui/components/todo-placeholder";

// TO-DO: Implement per-client sites list — Cloudflare Pages projects, domains, deploy status.
export function ClientSitesPage() {
  return (
    <TodoPlaceholder
      title="Client Sites"
      description="List of Cloudflare Pages sites for this client, including deployment status and domain mappings. Requires sites API endpoint."
    />
  );
}
